<template>
  <svg
    width="6"
    height="13"
    viewBox="0 0 6 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="6"
      height="12"
      rx="1"
      fill="#FF2E2D"
    />
  </svg>
</template>
